<template>
  <div class="row align-items-center my-5" style="margin: 0">
    <div class="col-5 my-4">
      <div class="row justify-content-around">
        <select class="col-5">
          <option value="volvo">主題</option>
          <option value="saab">Saab</option>
          <option value="mercedes">Mercedes</option>
          <option value="audi">Audi</option>
        </select>
        <select class="col-5">
          <option value="volvo">模式</option>
          <option value="saab">Saab</option>
          <option value="mercedes">Mercedes</option>
          <option value="audi">Audi</option>
        </select>
      </div>
    </div>
    <div class="col-2"></div>
    <div class="col-5">
      目前已選的題目有  {{usedLength}}  題
    </div>
    <div class="col-5">
      <div class="wrapper">
        <div class="scrollbar" id="style-3">
          <div class="force-overflow">
            <ul v-for="(item, index) in unusedData" :key='index' class='p-0 m-0'>
              <li>
                <span @click="userSelected(item)" :class="{'active': selectedData.some((el)=> {return el.id === item.id} )}">{{item.country}} - {{item.topic}}</span>
                <img style="width:2rem; height:2rem; cursor: pointer;" src="@/assets/images/btn_eye.png" alt="" @click="openDetail">
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="col-2">
      <button type="button" @click="addUsedData" class="btn btn-danger">> ></button>
      <button type="button" @click="removeUsedData" class="btn btn-primary">< <</button>
    </div>
    <div class="col-5">
      <div class="wrapper">
        <div class="scrollbar" id="style-3">
          <div class="force-overflow">
            <ul v-for="(item, index) in usedData" :key='index' class='p-0 m-0'>
              <li>
                <span @click="userSelected(item)" :class="{'active': selectedData.some((el)=> {return el.id === item.id} )}" >{{index + 1}}. {{item.country}} - {{item.topic}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <detailPage @closeDetail="closeDetail" v-if="isOpen" />
  </div>
</template>

<script>
import detailPage from '@/components/DetailPage.vue'
export default {
  name: 'FormAR',
  components: {
    detailPage
  },
  data () {
    return {
      unusedData: [
        {
          id: '1',
          country: '美國',
          topic: '自由女神像'
        },
        {
          id: '2',
          country: '美國',
          topic: '灰熊'
        },
        {
          id: '3',
          country: '美國',
          topic: '星巴克'
        }
      ],
      selectedData: [],
      usedData: [],
      isOpen: false
    }
  },
  computed: {
    usedLength () {
      return this.usedData.length
    }
  },

  methods: {
    userSelected (item) {
      let idx = this.selectedData.map((el) => { return el.id }).indexOf(item.id)
      idx < 0 ? this.selectedData.push(item) : this.selectedData.splice(idx, 1)
    },
    addUsedData () {
      this.usedData = this.usedData.concat(this.selectedData)
      this.unusedData = this.unusedData.filter((el) => { return this.selectedData.indexOf(el) === -1 })
      this.usedData = this.usedData.filter(function (el, idx, arr) {
        return arr.indexOf(el) === idx
      })
      this.selectedData = []
    },
    removeUsedData () {
      let data = this.unusedData.concat(this.selectedData)
      data.sort(function (a, b) {
        return a.id - b.id
      })
      this.unusedData = data
      this.usedData = this.usedData.filter((el) => { return this.selectedData.indexOf(el) === -1 })
      this.unusedData = this.unusedData.filter(function (el, idx, arr) {
        return (arr.indexOf(el) === idx)
      })
      this.selectedData = []
    },
    openDetail () {
      this.isOpen = true
    },
    closeDetail (item) {
      this.isOpen = item
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
select {
  border: rgba(0,0,0,0.3) 2px solid;
  border-radius: 5px;
  outline: none;
  padding: 2px;
}
.btn {
  margin: 10% 20% ;
  width: 60%;
}
.scrollbar {
  height: 300px;
  width: 100%;
  overflow-y: auto;
}
.force-overflow {
  min-height: 1800px;
}
.wrapper {
  text-align: left;
  border: solid 2px rgba(0,0,0,0.3);
  padding: 5px;
  border-radius: 10px;
  padding: 10px 20px;
}
#style-3::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}
#style-3::-webkit-scrollbar {
  width: 2px;
  background-color: #F5F5F5;
}
#style-3::-webkit-scrollbar-thumb {
  background-color: #000000;
}
li {
  list-style: none;
  display: flex;
  justify-content:space-between;
  span {
    width: 90%;
    line-height: 2rem;
    padding-left: 1rem;
    cursor: pointer;
  }
  img {
    cursor: pointer;
  }
}
.active {
  background-color: #d6d6d6;
}
</style>
